import {
  getMailingEvents,
  getUserData,
  saveInMailingEvents,
  saveMailingEventToLocalStorage,
  setUserData,
} from '~/actions/mailing/utils/mailingLocaleStorageControl';
import { customEvent } from '~/clientEvent';
import { GET_PARAM_FOR_ED_LETTER_UTM, KEY_EMAIL_FORWARDING_STORAGE } from '~/constants';
import { deleteFromLocalStorage, getFromLocalStorage } from '~/helpers/storage';
import { clickstreamLogger } from '~/logging';

/**
 * Событие добавления товара в корзину
 * @param productId
 * @param productCount
 * @param items
 * @param eventUuid
 * @returns userData
 */
export const mailingAddToBasket = (
  productId: string,
  productCount: number,
  items: IBasketItem[],
  eventUuid: string
): { userData: IUserDataForEvent } => {
  if (!productId) {
    clickstreamLogger.error('Добавление товара в корзину: ID товара не задан.');

    return null;
  }
  const userData = getUserData();

  if (!userData?.email) {
    saveMailingEventToLocalStorage('add-to-basket', {
      productId,
      productCount,
      items,
      eventUuid,
    });

    return null;
  }

  return {
    userData,
  };
};

/**
 * Завершение заказа(транзакция)
 * @param items
 * @param transactionId
 * @param eventUuid
 * @returns userData, sberleadLetterUtm
 */
type TMailingAddToPaymentOutData = {
  sberleadLetterUtm?: string;
  userData?: IUserDataForEvent;
};
export const mailingAddToPayment = (
  items: IBasketItem[],
  transactionId: string,
  eventUuid: string
): TMailingAddToPaymentOutData => {
  if (!items || !items.length || !transactionId) {
    clickstreamLogger.error('Совершение транзакции: список товаров не задан или отсутствует transactionId');

    return null;
  }
  const outData: TMailingAddToPaymentOutData = {};
  const userData = getUserData();
  userData?.email
    ? outData.userData = { ...userData }
    : saveMailingEventToLocalStorage('add-to-payment', {
      items,
      transactionId,
      eventUuid,
    });
  const sberleadLetterUtm = getFromLocalStorage<string>(
    KEY_EMAIL_FORWARDING_STORAGE,
    GET_PARAM_FOR_ED_LETTER_UTM
  );
  if (sberleadLetterUtm) {
    outData.sberleadLetterUtm = sberleadLetterUtm;
    deleteFromLocalStorage(
      KEY_EMAIL_FORWARDING_STORAGE,
      GET_PARAM_FOR_ED_LETTER_UTM
    );
  }
  
  return outData;
};

/**
 * Событие удаления товара из корзины.
 * @param productId
 * @param items
 * @param eventUuid
 * @returns userData
 */
export const mailingDeleteFromBasket = (
  productId: string,
  items: IBasketItem[],
  eventUuid: string
): { userData: IUserDataForEvent } => {
  if (!productId) {
    clickstreamLogger.error(
      'Удаление товара из корзины товара в корзину: ID товара не задан.'
    );

    return null;
  }
  const userData = getUserData();
  if (!userData?.email) {
    saveMailingEventToLocalStorage('delete-from-basket', {
      productId,
      items,
      eventUuid,
    });

    return null;
  }

  return {
    userData,
  };
};

/**
 * Изменение количества товара в корзине
 * @param productId
 * @param quantity
 * @param items
 * @param eventUuid
 * @returns userData
 */
export const mailingChangeItemsCountInBasket = (
  productId: string,
  quantity: number,
  items: IBasketItem[],
  eventUuid: string
): { userData: IUserDataForEvent } => {
  !productId &&
    clickstreamLogger.error(
      'Изменение количества товаров в корзине: productId товара не задан.'
    );
  !quantity &&
    clickstreamLogger.error(
      'Удаление товара из корзины: Количество товара не задано.'
    );

  if (!productId || !quantity) return null;

  const userData = getUserData();
  if (!userData?.email) {
    saveMailingEventToLocalStorage('change-items-count-in-basket', {
      productId,
      quantity,
      items,
      eventUuid,
    });

    return null;
  }

  return {
    userData,
  };
};

/**
 * Очищение корзины
 * @param items
 * @param eventUuid
 * @returns userData
 */
export const mailingClearBasket = (
  items: IBasketItem[],
  eventUuid: string
): { userData: IUserDataForEvent } => {
  const userData = getUserData();
  if (!userData?.email) {
    saveMailingEventToLocalStorage('clear-basket', {
      items,
      eventUuid,
    });

    return null;
  }

  return {
    userData,
  };
};

/**
 * Создает запись в LocalStorage с данными пользователя
 * @param userData: IUserDataForEvent
 */
export const mailingGetEmail = (userData: IUserDataForEvent) => {
  setUserData(userData);
  const savedMailingEvents = getMailingEvents();
  while (savedMailingEvents && savedMailingEvents?.length !== 0) {
    const savedMailingEvent = savedMailingEvents.shift();
    saveInMailingEvents(savedMailingEvents);
    customEvent(savedMailingEvent.type as ClientEventType, {
      ...savedMailingEvent.detail,
      userData,
    });
  }
};
